import React from "react";
import { motion } from "framer-motion";

const RocketAnimation = ({ delay }) => {
  return (
    <motion.img
      src="https://platovideo.z13.web.core.windows.net/rocket.png" // Use your rocket image path
      alt="Rocket"
      className=""
      style={{height:"90px", boxShadow:"none"}}
      initial={{ x: -0.3 * window.innerWidth, y: 0.03 * window.innerHeight }}
      animate={{
        x: [-0.3 * window.innerWidth, 0.25* window.innerWidth],
        y: [0.1 * window.innerHeight, 0.05*window.innerHeight, 0.0075*window.innerHeight, 0.05*window.innerHeight,0.1* window.innerHeight], // Moves from bottom to top
        rotate: [0, 90], 
      }}
      transition={{
        duration: 18, // Random speed
        ease: "linear",
        repeat: Infinity,
        //repeatDelay: delay,
      }}
    />
  );
};
const Rocket = () => {
    return (
    <>
    {[...Array(1)].map((_, i) => (
        <RocketAnimation key={i} />
      ))}
    </>
    )
}

export default Rocket;

